// 用户 token { string }
const USER_ACCESS_UTOKEN_KEY = 'utoken';
const USER_ACCESS_ACCESSTOKEN_KEY = 'accesstoken';
const USER_ACCESS_TOKEN_KEY = 'Token';
// 用户信息 { object }
const USER_INFO_KEY = 'User';
// 连接设备信息 { string }
const CONNECT_DEVICE_KEY = 'ConnectDevice';
// 连接设备的 ID { string }
const CONNECT_DEVICE_ID_KEY = 'ConnectDeviceId';
// 最后连接的设备 { string }
const LAST_CONNECT_TYPE_KEY = 'ConnectType';
// 语言 { string }
const INTL_LANG_KEY = 'IntlLang';
// 意见反馈缓存 { object }
const FEEDBACK_CACHE_KEY = 'Feedback';
// 记住是否更新
const REMIND_UPDATE = 'RemindUpdate';
// 不再更新
const IGNORE_UPDATE_VERSIONS = 'IgnoreUpdateVersions';
// 已加载的扩张的名称
const LOADED_EXTENSIONS = 'LoadedExtensions';

const INSTALLED_EXT = 'InstalledExtensions';
// 是否为国际版
const INTERNATIONAL_VERSION = 'InternationalVersion';

export default {
    USER_ACCESS_TOKEN_KEY,
    USER_ACCESS_ACCESSTOKEN_KEY,
    USER_ACCESS_UTOKEN_KEY,
    USER_ACCESS_ACCESSTOKEN_KEY,
    USER_INFO_KEY,
    CONNECT_DEVICE_KEY,
    CONNECT_DEVICE_ID_KEY,
    LAST_CONNECT_TYPE_KEY,
    INTL_LANG_KEY,
    FEEDBACK_CACHE_KEY,
    REMIND_UPDATE,
    IGNORE_UPDATE_VERSIONS,
    LOADED_EXTENSIONS,
    INSTALLED_EXT,
    INTERNATIONAL_VERSION
};